import { z } from 'zod';

export const DocRevisionSummary = z.object({
  id: z.string().uuid(),
  page_id: z.string().uuid(),
  version: z.number().int(),
  updated_at: z.string().datetime({ offset: true }),
  updated_by_email: z.string().nullable(),
  reason: z.string().nullable(),
  lines_added: z.number().int(),
  lines_removed: z.number().int(),
  is_from_seed: z.boolean(),
  is_revert_of: z.number().int().nullable(),
});
export type DocRevisionSummary = z.infer<typeof DocRevisionSummary>;

export const DocRevisionsListResponse = z.object({
  revisions: z.array(DocRevisionSummary),
  total: z.number().int(),
});
export type DocRevisionsListResponse = z.infer<typeof DocRevisionsListResponse>;

export const DocRevisionDetail = z.object({
  id: z.string().uuid(),
  page_id: z.string().uuid(),
  version: z.number().int(),
  updated_at: z.string().datetime({ offset: true }),
  updated_by_email: z.string().nullable(),
  reason: z.string().nullable(),
  body_md: z.string(),
  body_html: z.string(),
  is_from_seed: z.boolean(),
  is_revert_of: z.number().int().nullable(),
});
export type DocRevisionDetail = z.infer<typeof DocRevisionDetail>;

export const DocDiffResponse = z.object({
  left: z.object({
    version: z.number().int(),
    body_md: z.string(),
    updated_at: z.string().datetime({ offset: true }),
  }),
  right: z.object({
    version: z.number().int(),
    body_md: z.string(),
    updated_at: z.string().datetime({ offset: true }),
  }),
  diff_html: z.string(),
});
export type DocDiffResponse = z.infer<typeof DocDiffResponse>;

export const DocRestoreRequest = z
  .object({
    from_version: z.number().int().min(1),
    reason: z.string().min(1).max(2000),
  })
  // zod-strict-ok: input request-body
  .strict();
export type DocRestoreRequest = z.infer<typeof DocRestoreRequest>;
